import { useQueryPaymentCardGateway } from '@/api/payment/queries'

export const useMissingProfile = (): string[] => {
  const { data } = useQueryPaymentCardGateway()
  return data?.pagarme.missing_profile ?? []
}
